import React from 'react';
export const FooterSection = () => {
  return <footer className="w-full bg-black text-white" data-id="element-117">
      <div className="container mx-auto px-4 py-8" data-id="element-118">
        <div className="text-center" data-id="element-119">
          <p className="text-gray-400 text-sm" data-id="element-120">
            &copy; 2025 Binary Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};